"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowHighlighting = void 0;
const react_1 = require("react");
const ramda_1 = require("ramda");
const DELAY = 500;
const FADE_DELAY = 1000;
const useRowHighlighting = ({ targetRef, className, scrollToHighlightedItem, shouldRowBeHighlighted = (0, ramda_1.always)(false), value, }) => {
    const previousValue = (0, react_1.useRef)(value);
    (0, react_1.useEffect)(() => {
        const shouldBeHighlighted = shouldRowBeHighlighted === null || shouldRowBeHighlighted === void 0 ? void 0 : shouldRowBeHighlighted(value, previousValue.current);
        if (!shouldBeHighlighted) {
            return;
        }
        const target = targetRef.current;
        if (scrollToHighlightedItem) {
            target.scrollIntoView();
        }
        target.classList.add(className);
        let shadowTimeoutId;
        const highlightingTimeoutId = setTimeout(() => {
            target.classList.remove(className);
            target.style.transition = `background-color ${FADE_DELAY}ms`;
            shadowTimeoutId = setTimeout(() => {
                target.style.transition = '';
            }, FADE_DELAY);
        }, DELAY);
        previousValue.current = value;
        return () => {
            clearTimeout(highlightingTimeoutId);
            clearTimeout(shadowTimeoutId);
        };
    }, [className, scrollToHighlightedItem, shouldRowBeHighlighted, targetRef, value]);
};
exports.useRowHighlighting = useRowHighlighting;
exports.default = exports.useRowHighlighting;
